// import {setFWUFinished, setFWUProgress} from '../../state/ducks/iotDevice/actions';
import dateTimeUtils from '../../utils/dateTimeUtils';
import {log} from '../log';
import {getUserAgent} from '../user/userAgentService';
import framesProcessingService from '../device/framesProcessingService';
import fwuTargetService from './fwuTargetService';

export default class BaseFwuClient {
    constructor({fwuPackageData, fwuTarget}) {
        this.fwuPackageData = fwuPackageData;
        this.fwuTarget = fwuTarget;

        this.currentEventType = undefined;
    }

    startTs;

    setStartTs = () => {
        this.startTs = dateTimeUtils.getNowUtcTsUnix();
    };

    onFwuErrorBase = (props) => {
        log.info(`BaseFwuClient: onFwuErrorBase is called fwuTarget: ${this.fwuTarget}`);
        framesProcessingService.restart();
        this.publishFwuError(props);
    };

    onFwuFinishBase = () => {
        log.info(`BaseFwuClient: onFwuFinishBase is called fwuTarget: ${this.fwuTarget}`);
        framesProcessingService.restart();
        this.publishFwuFinish();
        // TODO: IA
        // dispatch(setFWUFinished());
    };

    onFwuStopBase = () => {
        framesProcessingService.restart();
    };

    publishFwuError = ({errorCode, lastRequestFrames, lastResponseFrames, errorFrame}) => {
        this.onFwuError?.({
            errorCode,
            errorFrame,
            eventType: this.currentEventType,
            fwuTarget: this.fwuTarget,
            lastRequestFrames,
            lastResponseFrames,
            startTs: this.startTs,
            userAgent: getUserAgent(),
        });
    };

    publishFwuFinish = () => {
        this.onFwuFinish?.(this.fwuTarget);
    };

    sendStatusMessage = (status) => {
        if (status) {
            this.onFwuStatusEvent?.(status);

            const {
                status: {progress},
            } = status;

            console.log('progress', progress);

            // TODO: IA
            // dispatch(setFWUProgress(progress));
        }
    };

    isFwuHolderRelatedTarget = () => fwuTargetService.isFwuTargetHolderRelated(this.fwuTarget);
}
